const getters = {
  token: state => state.user.token,
  // 要取到里面的值
  name: state => state.user.user.name,
  userId: state => state.user.user.id,
  user: state => state.user.user,
  isModify: state => state.isModify
}
export default getters
